<button
  id="follow-button"
  type="button"
  class="btn btn-primary m-r-10 m-b-5"
  [ngClass]="{
    disabled: isSubmitting,
    'btn-outline-secondary': !profile.isFollowing.following,
    'btn-secondary': profile.isFollowing.following
  }"
  (click)="toggleFollowing()"
>
  <i
    class="icofont"
    [ngClass]="{
      'icofont-plus-circle': !profile.isFollowing.following,
      'icofont-minus-circle': profile.isFollowing.following
    }"
  ></i>
  &nbsp; {{ profile.isFollowing.following ? "Unfollow" : "Follow" }}

  <!-- Content marker -->
  <ng-content></ng-content>
</button>
